<template>
	<router-view></router-view>
</template>

<script>
//로그인, 비밀번호 변경, 비밀번호 초기화 페이지를 제외한 모든 나머지 화면의 base가 되는 Layout
//라우팅 용도로 사용
import { rootComputed, rootMethods } from '@/store/common/helpers';

export default {
	mounted() {
		//공지사항 웹소켓 리스너 등록
		if (!this.listener) {
			this.subscribeNotification();
		}

		//제어권 반납을 위한 화면 정보 저장
		const name = this.$route.name.split('Screen')[0];

		this.scrType = this.getMenu_({ name }).scrType;
		this.scrId = this.$route.path.split('/')[this.$route.path.split('/').length - 1];
	},

	// beforeDestroy 될 때
	beforeDestroy() {
		// Local 메뉴일 경우 제어권 반납 함수 호출
		if (this.scrType === 'L') {
			this.userLockReturn(this.scrId);
		}
		this.listener = null;
	},

	data() {
		return {
			listener: null, // 공지사항 웹소켓 리스터
			scrType: '', //현재 화면의 메뉴 타입
			scrId: '' // 현재 화면의 아이디
		};
	},

	computed: {
		...rootComputed,

		wsTarget() {
			return process.env.VUE_APP_WS_TARGET;
		}
	},

	watch: {
		// Local 메뉴일 경우 이동 전 화면의 제어권 반납
		//화면 정보 변경 감지
		$route(nextRoute, preRoute) {
			const name = preRoute.name.split('Screen')[0];
			const preScrId = preRoute.path.split('/')[preRoute.path.split('/').length - 1];

			this.scrType = this.getMenu_({ name }).scrType;
			this.scrId = nextRoute.path.split('/')[nextRoute.path.split('/').length - 1];

			if (preScrId && preScrId !== 'sitemap' && preScrId !== 'local' && preScrId !== 'home' && this.getMenu_({ name }).scrType === 'L') {
				this.userLockReturn(preScrId);
			}
		}
	},

	methods: {
		...rootMethods,

		//공지사항 웹소켓 리스너 등록
		subscribeNotification() {
			this.listener = new this.$sf_topicListener({
				topic: 'notification',
				onMessage: this.onNotiMessage,
				// target: this.wsTarget
			});
		},

		//공지사항 웹소켓 수신
		onNotiMessage({ message }) {
			const parsedMessage = JSON.parse(message); //메세지 내용 파싱
			this.notify(parsedMessage); //공지사항 Toast 알림 함수 호출
		},

		//공지사항 Toast 알림 표시 함수
		notify({ notiTitle, notiContent, regId, regDt }) {
			this.$sf_toast({
				title: notiTitle,
				icon: '',
				message: notiContent,
				position: `top-left`,
				option: { duration: 0 }
			});
		},

		// Local 메뉴일 경우 제어권 반납 함수
		userLockReturn(scrId) {
			this.$sf_toggleLoading(true);
			this.userLockReturn_({ scrId })
				.then(header => {
					//제어권 가지고 있지 않은 경우 제외
					if (header.code !== 1) {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					}
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>

<style></style>
